function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/React.createElement("filter", {
  x: "-18.1%",
  y: "-15.3%",
  width: "136.1%",
  height: "136.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.294117647   0 0 0 0 0.250980392   0 0 0 0 0.22745098  0 0 0 0.3 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu/icon-messages",
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "messages-white"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "white-circle"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F3EFEA",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}))), /*#__PURE__*/React.createElement("g", {
  id: "messages-blue",
  transform: "translate(5.000000, 8.000000)",
  fill: "#61B3CD",
  stroke: "#61B3CD",
  strokeWidth: 0.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6553083,8.23311667 L3.228225,8.23311667 C3.01805833,8.23311667 2.84580833,8.4032 2.84580833,8.61445 C2.84580833,8.82461667 3.01805833,8.9947 3.228225,8.9947 L13.654225,8.9947 C13.8643917,8.9947 14.0355634,8.82461667 14.0355634,8.61445 C14.0366417,8.4032 13.8643917,8.23311667 13.6553083,8.23311667",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6553083,10.6368167 L3.228225,10.6368167 C3.01805833,10.6368167 2.84580833,10.8069 2.84580833,11.01815 C2.84580833,11.2283167 3.01805833,11.3984 3.228225,11.3984 L13.654225,11.3984 C13.8643917,11.3984 14.0355634,11.2283167 14.0355634,11.01815 C14.0366417,10.8069 13.8643917,10.6368167 13.6553083,10.6368167",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.44176667,13.0404083 L3.22876667,13.0404083 C3.01751667,13.0404083 2.84635,13.2104917 2.84635,13.4217417 C2.84635,13.6319083 3.01751667,13.8019917 3.22876667,13.8019917 L8.44176667,13.8019917 C8.65085,13.8019917 8.8231,13.6319083 8.8231,13.4217417 C8.8231,13.2104917 8.65085,13.0404083 8.44176667,13.0404083",
  id: "Fill-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6750583,3.425825 L13.247975,3.425825 C13.0388917,3.425825 12.8666417,3.59590833 12.8666417,3.80715833 C12.8666417,4.017325 13.0388917,4.18740833 13.247975,4.18740833 L23.6750583,4.18740833 C23.885225,4.18740833 24.0563917,4.017325 24.0563917,3.80715833 C24.0563917,3.59590833 23.885225,3.425825 23.6750583,3.425825",
  id: "Fill-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6750583,5.829525 L18.4620583,5.829525 C18.2508083,5.829525 18.080725,5.99960833 18.080725,6.21085833 C18.080725,6.421025 18.2508083,6.59110833 18.4620583,6.59110833 L23.6750583,6.59110833 C23.885225,6.59110833 24.0563917,6.421025 24.0563917,6.21085833 C24.0563917,5.99960833 23.885225,5.829525 23.6750583,5.829525",
  id: "Fill-9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(0.000000, 4.770242)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.120325,9.261525 C16.120325,10.197525 15.359825,10.958025 14.4249083,10.958025 L6.636825,10.958025 C6.36490833,10.958025 6.10815833,11.0609417 5.91099167,11.2483583 L2.886325,14.1191917 L3.31424167,11.7466917 C3.38790833,11.335025 3.071575,10.958025 2.65449167,10.958025 L2.45840833,10.958025 C1.52240833,10.958025 0.761908333,10.197525 0.761908333,9.261525 L0.761908333,3.08219167 C0.761908333,2.14619167 1.52240833,1.38460833 2.45840833,1.38460833 L14.4249083,1.38460833 C15.359825,1.38460833 16.120325,2.14619167 16.120325,3.08219167 L16.120325,9.261525 Z M14.4249083,0.623025 L2.45840833,0.623025 C1.10315833,0.623025 0.000325,1.72585833 0.000325,3.08219167 L0.000325,9.261525 C0.000325,10.6178583 1.10315833,11.7206917 2.45840833,11.7206917 L2.54399167,11.7206917 L2.05215833,14.4539417 C2.005575,14.711775 2.129075,14.9696083 2.36090833,15.0941917 C2.59490833,15.2198583 2.876575,15.1786917 3.065075,14.9999417 L6.435325,11.8008583 C6.48949167,11.7488583 6.562075,11.7206917 6.636825,11.7206917 L14.4249083,11.7206917 C15.7801583,11.7206917 16.8819083,10.6178583 16.8819083,9.261525 L16.8819083,3.08219167 C16.8819083,1.72585833 15.7801583,0.623025 14.4249083,0.623025 L14.4249083,0.623025 Z",
  id: "Fill-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-16",
  transform: "translate(10.833333, 0.436908)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.941175,0.646641667 L2.31584167,0.646641667 C1.08950833,0.646641667 0.090675,1.645475 0.090675,2.87180833 L0.090675,3.55755833 C0.090675,3.767725 0.260758333,3.93780833 0.470925,3.93780833 C0.682175,3.93780833 0.852258333,3.767725 0.852258333,3.55755833 L0.852258333,2.87180833 C0.852258333,2.06580833 1.50875833,1.408225 2.31584167,1.408225 L12.941175,1.408225 C13.7482583,1.408225 14.4058417,2.06580833 14.4058417,2.87180833 L14.4058417,8.288475 C14.4058417,9.09555833 13.7482583,9.75205833 12.941175,9.75205833 L12.7667583,9.75205833 C12.369175,9.75205833 12.0690917,10.1106417 12.1395083,10.501725 L12.495925,12.480975 L9.90459167,10.020725 C9.72150833,9.84739167 9.483175,9.75205833 9.23075833,9.75205833 L7.448675,9.75205833 C7.23850833,9.75205833 7.06734167,9.923225 7.06734167,10.1333917 C7.06734167,10.3435583 7.23850833,10.5136417 7.448675,10.5136417 L9.23075833,10.5136417 C9.28709167,10.5136417 9.340175,10.5353083 9.38025833,10.573225 L12.3735083,13.413725 C12.5555083,13.5870583 12.827425,13.6238917 13.048425,13.5036417 C13.2705083,13.384475 13.3885917,13.137475 13.344175,12.890475 L12.9162583,10.5136417 L12.941175,10.5136417 C14.1685917,10.5136417 15.167425,9.51589167 15.167425,8.288475 L15.167425,2.87180833 C15.167425,1.64439167 14.1685917,0.646641667 12.941175,0.646641667",
  id: "Fill-14"
})))))));

function SvgMessagesWhitesvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesWhitesvg);
export default __webpack_public_path__ + "static/media/messages-whitesvg.09114439.svg";
export { ForwardRef as ReactComponent };